import { render, staticRenderFns } from "./goods-card.vue?vue&type=template&id=bba0368c&scoped=true"
import script from "./goods-card.vue?vue&type=script&lang=js"
export * from "./goods-card.vue?vue&type=script&lang=js"
import style0 from "./goods-card.vue?vue&type=style&index=0&id=bba0368c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba0368c",
  null
  
)

export default component.exports